import { cancel, fork, take } from 'redux-saga/effects';

/**
 * Cancel saga type.
 * @type {String}
 */
export const CANCEL_SAGAS_HMR = 'CANCEL_SAGAS_HMR';

/**
 * Create an abortable saga for properly handling HMR.
 * @param {Function} saga Saga flow
 * @returns Saga flow, with abortable behavior on dev
 */
export function createAbortableSaga(saga) {
    if (process.env.NODE_ENV === 'development') {
        return function* main() {
            const sagaTask = yield fork(saga);

            yield take(CANCEL_SAGAS_HMR);
            yield cancel(sagaTask);
        };
    }
    return saga;
}

/**
 * Saga manager for handling HMR behavior.
 */
export default {
    /**
     * Start sagas of app.
     * @param {Function} sagaMiddleware Saga middleware connected to store.
     */
    startSagas(sagaMiddleware, appSagas) {
        sagaMiddleware.run(createAbortableSaga(appSagas));
    },

    /**
     * Cancel saga.
     * @param {Object} store Connected store.
     */
    cancelSagas(store) {
        store.dispatch({
            type: CANCEL_SAGAS_HMR,
        });
    },
};
